module.exports = __webpack_public_path__ + "img/thumbnail_BlackRhinoceros_j_normal.008fe7e3.png";